const Footer = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navItems = [
    { label: '事業内容', id: 'business' },
    { label: '拠点・設備', id: 'facility' },
    { label: '会社概要', id: 'company' },
    { label: 'お問い合わせ', id: 'contact' },
  ];

  return (
    <footer style={{ backgroundColor: '#1A2840' }}>
      {/* フッター上部 */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* 会社情報 */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/ca05ad39-7205-4e06-8747-8cc7a6d92761.png"
                alt="株式会社テクノワークス"
                className="h-9 w-auto object-contain"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <p className="text-sm font-semibold text-white mb-1">株式会社テクノワークス</p>
            <p className="text-xs leading-relaxed" style={{ color: '#8A9BB5' }}>
              〒135-0062<br />
              東京都江東区東雲1丁目1番1号<br />
              TEL: 03-1234-5678
            </p>
          </div>

          {/* ナビゲーション */}
          <div>
            <h4 className="text-xs font-semibold mb-4 tracking-widest" style={{ color: '#8A9BB5', letterSpacing: '0.12em' }}>
              MENU
            </h4>
            <ul className="space-y-2">
              {navItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-sm text-white/75 hover:text-white transition-colors cursor-pointer text-left whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 許可情報 */}
          <div>
            <h4 className="text-xs font-semibold mb-4 tracking-widest" style={{ color: '#8A9BB5', letterSpacing: '0.12em' }}>
              LICENSE
            </h4>
            <ul className="space-y-2 text-xs" style={{ color: '#8A9BB5' }}>
              <li className="flex items-start gap-1.5">
                <div className="w-3 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-government-line text-xs"></i>
                </div>
                <span className="leading-relaxed">国土交通大臣許可（般-05）<br />第XXXXX号</span>
              </li>
              <li className="flex items-start gap-1.5">
                <div className="w-3 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-shield-check-line text-xs"></i>
                </div>
                <span>電気工事業・管工事業・土木工事業</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* フッター下部 */}
      <div className="border-t" style={{ borderColor: '#2A3D5C' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs" style={{ color: '#5A6E88' }}>
            &copy; {new Date().getFullYear()} 株式会社テクノワークス All Rights Reserved.
          </p>
          <p className="text-xs" style={{ color: '#5A6E88' }}>
            建設業許可：国土交通大臣許可（般-05）第XXXXX号
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
